import { useQuery } from '@tanstack/react-query'
import _ from 'lodash'
import { convertCaseList, ConvertType } from '@/shared/utils/convertString'

import axiosInstance from '@/shared/utils/axios'

export interface IPreNoticeInfoResponse {
  sub_text: string
  banner_text: string
}

export const fetchPreNoticeInfo = async () => {
  const response = await axiosInstance.get<IPreNoticeInfoResponse>(
    `${process.env.NEXT_PUBLIC_API_ENDPOINT}/course/v1/early-bookings/info`,
  )

  return convertCaseList(response.data, ConvertType.CAMEL)
}

export const usePreNoticeInfoQuery = () => {
  return useQuery({
    queryKey: ['preNoticeInfo'],
    queryFn: () => fetchPreNoticeInfo(),
  })
}
